/* istanbul ignore file */
import { AppBar } from '@material-ui/core';
import { getColor } from 'common/constants/_colors';
import { SPACES } from 'common/constants/sizes';
import styled from 'styled-components';

export const StyledAppBar = styled(AppBar)`
  ${({ height }) => `height: ${height ? height : '8rem'}`};
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row !important;
  padding-right: ${SPACES.medium};
  padding-left: ${SPACES.medium};
  box-shadow: none !important;
  ${({ isontop }) => `z-index: ${isontop ? 1400 : 10} !important;`};
  ${({ isonboarding }) =>
    isonboarding
      ? `border-bottom: 1px solid ${getColor('catskillWhite')}`
      : ``};
`;

export const Logo = styled.img`
  height: 100%;
  width: 14rem;
`;
